import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsCheckioComponent } from './simple-icons-checkio.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsCheckioComponent ],
    exports:      [ SimpleIconsCheckioComponent ],
    bootstrap:    []
})
export class SimpleIconsCheckioModule {}
